export class Balance {
    public id                   :   string;
    public openingBalance       :   number;
    public closeingBalance      :   number;

    constructor(data: any = {}) {
        this.id                 =   data.id                 ||  '';
        this.openingBalance     =   data.openingBalance     ||  0;
        this.closeingBalance     =   data.closeingBalance   ||  0;
    }

    public toJson() {
        return {
            ...this
        };
    }
}